<template>
  <div>
    <p class="text-h5">近期交易</p>

    <el-table v-if="sales" :data="sales.rows" style="width: 100%; padding-top: 15px">
      <el-table-column label="機台編號">
        <template slot-scope="scope">
          {{ scope.row.AssetNo }}
        </template>
      </el-table-column>

      <el-table-column label="客戶">
        <template slot-scope="scope">
          {{ scope.row.mvm.client.name }}
        </template>
      </el-table-column>

      <el-table-column label="品名">
        <template slot-scope="scope">
          {{ scope.row.ProductName }}
        </template>
      </el-table-column>

      <el-table-column label="價格">
        <template slot-scope="scope">
          {{ scope.row.PayAmt }}
        </template>
      </el-table-column>

      <el-table-column label="結果">
        <template slot-scope="scope">
          {{ scope.row.Result | resultFilter }}
        </template>
      </el-table-column>

      <el-table-column label="交易時間">
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTimeFilter }}
        </template>
      </el-table-column>
    </el-table>
    <div class="text-center bg-white py-2" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { axiosApi, getLastSales } from '@/api/transaction';
import { getSaleOutline } from '@/api/dashboard';
import dayjs from 'dayjs';
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        1: 'success',
        0: 'danger',
      };
      return statusMap[status];
    },
    statusFilterText(status) {
      const statusMap = {
        1: '在線',
        0: '離線',
        4: '未部署',
      };
      return statusMap[status];
    },
    dateTimeFilter(datetime) {
      return dayjs(datetime).utcOffset('+0800').format('YYYY/MM/DD HH:mm');
    },
    resultFilter(result) {
      const map = {
        Success: '成功',
        'Vendout Fail': '出貨失敗',
      };
      return map[result];
    },
  },
  data() {
    return {
      list: null,
      lastSales: {
        data: null,
      },
      sales: null,
    };
  },
  computed: {
    ...mapGetters('variable', ['company_id']),
  },
  watch: {
    async company_id() {
      this.sales = await getSaleOutline({ company_id: this.company_id });
    },
  },
  async created() {
    this.sales = await getSaleOutline({ company_id: this.company_id });
  },
};
</script>
